import { MessageCircle, Settings } from "lucide-react"
import { SidebarHeader } from "@/components/ui/sidebar"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip"
import { ChatSidebar } from "@/components/ChatSidebar"
import { SettingsSidebar } from "@/components/SettingsSidebar"
import { AnalyticsEvents, trackEvent } from "@/lib/analytics"

export function AppSidebar() {
  return (
    <Tabs
      defaultValue="chat"
      className="flex min-h-0 flex-1 flex-col"
      onValueChange={(value) => {
        trackEvent(AnalyticsEvents.SidebarTabChanged, { tab: value })
      }}
    >
      <SidebarHeader className="flex-shrink-0">
        <TabsList
          variant="line"
          className="h-auto w-full justify-start gap-0 rounded-none bg-transparent p-0"
        >
          <Tooltip>
            <TooltipTrigger asChild>
              <span className="flex flex-1">
                <TabsTrigger
                  value="chat"
                  className="w-full gap-0 px-2 py-2"
                  aria-label="Chat"
                >
                  <MessageCircle className="size-4" />
                </TabsTrigger>
              </span>
            </TooltipTrigger>
            <TooltipContent
              side="bottom"
              sideOffset={2}
              className="px-2 py-1 text-[10px]"
            >
              Chat
            </TooltipContent>
          </Tooltip>
          <Tooltip>
            <TooltipTrigger asChild>
              <span className="flex flex-1">
                <TabsTrigger
                  value="settings"
                  className="w-full gap-0 px-2 py-2"
                  aria-label="Settings"
                >
                  <Settings className="size-4" />
                </TabsTrigger>
              </span>
            </TooltipTrigger>
            <TooltipContent
              side="bottom"
              sideOffset={2}
              className="px-2 py-1 text-[10px]"
            >
              Settings
            </TooltipContent>
          </Tooltip>
        </TabsList>
      </SidebarHeader>
      <TabsContent
        value="chat"
        className="mt-0 flex min-h-0 flex-1 overflow-hidden data-[state=inactive]:hidden"
      >
        <ChatSidebar />
      </TabsContent>
      <TabsContent
        value="settings"
        className="mt-0 flex min-h-0 flex-1 overflow-hidden data-[state=inactive]:hidden"
      >
        <SettingsSidebar />
      </TabsContent>
    </Tabs>
  )
}
